// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows: SRP — map public share API bundle to detail UI state.
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/**
 * Map GET /public/voice/share/{token} response to VoiceDetailModal internal state shape.
 * @param {object} bundle - API JSON body
 * @returns {object} Partial state for transcription view
 */
export function mapVoiceShareBundleToDetailState(bundle) {
  if (!bundle || !bundle.task_id) {
    return {
      fileId: null,
      fileName: '',
      transcriptionData: null,
      transcriptionUnavailable: 'Invalid share payload.',
      metadata: null,
      metadataUnavailable: true,
      analysisData: null,
    };
  }

  const fileId = bundle.task_id;
  const tp = bundle.transcription;
  let transcriptionData = null;
  let transcriptionUnavailable = null;

  if (tp?.success && tp.transcription) {
    const t = tp.transcription;
    transcriptionData = {
      transcription_text: t.raw_text,
      cleaned_text: t.cleaned_text,
      enhanced_text: t.enhanced_text,
      ollama_enhanced_text: t.ollama_enhanced_text,
      confidence_score: t.confidence,
      processing_time: (t.processing_time ?? 0) * 1000,
      speech_ratio: null,
      quality_score: null,
      original_language: t.language_detected,
      word_timestamps: t.word_timestamps,
      quality_warning: t.quality_warning || null,
    };
  } else {
    transcriptionUnavailable =
      tp?.message || 'Transcription not yet available for this task.';
  }

  const md = bundle.metadata;
  let metadata = null;
  let metadataUnavailable = false;
  if (md?.success && md.metadata) {
    metadata = {
      status: tp?.status ?? md.task_status,
      qa_criteria_id: null,
      ...md.metadata,
    };
  } else {
    metadataUnavailable = true;
  }

  let analysisData = null;
  const ar = bundle.analysis;
  if (ar?.success && ar?.analysis) {
    analysisData = ar;
  }

  const fileName = tp?.file_name || ar?.file_name || fileId;

  return {
    fileId,
    fileName,
    transcriptionData,
    transcriptionUnavailable,
    metadata,
    metadataUnavailable,
    analysisData,
  };
}
